import React, { useState } from 'react';
import DefaultEditor from "react-simple-wysiwyg";

interface CommonTextEditorProps {
    defaultValue?: string; 
    defaultName?: string; 
    defaultId?: string; 
    handleInputChange?:any;
    classs?:any;
}

const CommonTextEditor: React.FC<CommonTextEditorProps> = ({classs, defaultValue,defaultName, defaultId, handleInputChange}) => {
    return (
        <>
            <DefaultEditor value={defaultValue} onChange={handleInputChange} name={defaultName} id={defaultId}
            className={classs}/>
        </>
    );
}

export default CommonTextEditor;
